<template>
  <a-modal
    title="财产日志"
    :width="1500"
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
    :bodyStyle="{paddingTop:0}"
  >
    <a-card :bordered="false" v-if="currentRobotId">
      <div class="table-operator"></div>
      <s-table ref="table" rowKey="id" :columns="columns" :data="loadData">
        <span slot="serial" slot-scope="text">{{text}}</span>
        <span slot="type" slot-scope="text">
          <a-tag color="blue">{{text | getTypeTitle(type)}}</a-tag>
        </span>
        <span slot="balance" slot-scope="text">
          <span>{{ text || 0 | currency('￥') }}</span>
        </span>
         <span slot="integral" slot-scope="text">
           <span>{{ text / 100 || 0 }}</span>
         </span>
        <span slot="remark" slot-scope="text">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <span v-line-clamp="1">{{ text || '无' }}</span>
          </a-tooltip>
        </span>
        <span slot="createdt" slot-scope="text, record">
          <span>{{ record.createdt }}</span>
        </span>
      </s-table>
    </a-card>
  </a-modal>
</template>

<script>
import CapitalApi from '@/api/capital'
import { STable } from '@/components'
import { CAPITAL_TYPE } from '../../capital/data'
export default {
  components:{
    STable
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      loading: false,
      visible: false,
      currentRobotId: null,
      fansId: null,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '机器人ID',
          dataIndex: 'sub_id'
        },
        {
          title: '用户UID',
          dataIndex: 'userid'
        },
        {
          title: '微信昵称',
          dataIndex: 'get_user_info.nickname'
        },
        {
          title: '微信ID',
          dataIndex: 'wxid'
        },
        {
          title: '积分',
          dataIndex: 'integral',
          scopedSlots: { customRender: 'integral' }
        },
        {
          title: '操作金额',
          dataIndex: 'balance',
          scopedSlots: { customRender: 'balance' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 200,
          scopedSlots: { customRender: 'remark' }
        },
        {
          title: '类型',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' }
        },
        {
          title: '创建时间',
          scopedSlots: { customRender: 'createdt' },
          width: 180,
          sorter: true
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return CapitalApi.getCapitalLog(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId,
            search_condition: 3,
            keywords: this.fansId
          })
        )
      },
      // 类型
      type: CAPITAL_TYPE
    }
  },
  filters: {
    getTypeTitle(type, types) {
      const arr = types.filter(val => {
        return val.id == type
      })
      return arr[0]['title']
    }
  },
  created() {},
  methods: {
    show({ robotid,uid }) {
      console.log(robotid,uid)
      this.currentRobotId = Number(robotid)
      this.fansId = Number(uid)
      this.visible = true
    },
    handleCancel() {
      this.currentRobotId = null
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.table-operator {
  display: flex;
  flex-direction: row;
  align-items: center;
}
/deep/ .page-header {
  .extra {
    display: none;
  }
  .headerContent {
    flex: 0 1 100% !important;
  }
}
</style>
